App.angularApp.directive 'mfCarousel', ['$window', '$timeout', '$parse', ($window, $timeout, $parse) ->
    restrict: 'E'
    scope:
        mfCarouselOptions: '&mfCarouselOptions'
    link: ($scope, ele, attrs, $carousel) ->
        ele.find('mf-carousel-content').addClass 'mf-carousel-content'
        $carousel.options = angular.extend
            pixelsPerClick: 50
            durationOfClick: 100
        , $scope.mfCarouselOptions()
    controller: ['$scope', '$element', class MfCarouselCtrl
        constructor: ($scope, $element) ->
            @content = $element.find('mf-carousel-content')

        scrollLeft: () ->
            @content.animate
                scrollLeft: @content.scrollLeft() - @options.pixelsPerClick
            , @options.durationOfClick, 'linear'

        scrollRight: () ->
            @content.animate
                scrollLeft: @content.scrollLeft() + @options.pixelsPerClick
            , @options.durationOfClick, 'linear'
    ]
]

App.angularApp.directive 'mfCarouselLeft', ['$window', '$timeout', '$parse', ($window, $timeout, $parse) ->
    restrict: 'E'
    require: '^^mfCarousel'
    link: ($scope, ele, attrs, $carousel) ->
        ele.addClass 'mf-carousel-left'
        intervalIds = []
        ele.mousedown (evnt) ->
            return if evnt.button isnt 0
            $carousel.scrollLeft()
            intervalIds.push setInterval () ->
                $carousel.scrollLeft()
            , $carousel.options.durationOfClick
        ele.mouseup (evnt) ->
            while intervalIds.length > 0
                clearInterval intervalIds.pop()
]

App.angularApp.directive 'mfCarouselRight', ['$window', '$timeout', '$parse', ($window, $timeout, $parse) ->
    restrict: 'E'
    require: '^^mfCarousel'
    link: ($scope, ele, attrs, $carousel) ->
        ele.addClass 'mf-carousel-right'
        intervalIds = []
        ele.mousedown (evnt) ->
            return if evnt.button isnt 0
            $carousel.scrollRight()
            intervalIds.push setInterval () ->
                $carousel.scrollRight()
            , $carousel.options.durationOfClick
        ele.mouseup (evnt) ->
            while intervalIds.length > 0
                clearInterval intervalIds.pop()
]
